<template>
  <div class="toast-container">
    <div
      v-for="(toast, index) in toasts"
      :key="toast.id"
      class="toast"
      :class="toast.type"
    >
      <div class="toast-content">
        <span class="toast-text">{{ toast.message }}</span>
        <button class="toast-close" @click="removeToast(index)">×</button>
      </div>

      <!-- Progress bar -->
      <div
        class="toast-progress"
        :style="{ width: toast.progress + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toasts: []
    };
  },
  created() {
    this.$toastBus.$on('toast', this.addToast);
  },
  methods: {
  addToast(toast) {
    const uniqueKey = toast.key || toast.message;

    // Remove existing toast with same key before adding new one
    const existingIndex = this.toasts.findIndex(
      t => (t.key || t.message) === uniqueKey
    );
    if (existingIndex !== -1) {
      this.removeToast(existingIndex);
    }

    // Add new toast
    const id = Date.now() + Math.random();
    this.toasts.unshift({ ...toast, id, progress: 100 });

    // Start progress timer
    const duration = toast.duration || 3000;
    let start = Date.now();
    const index = 0; // new toast is at the front

    const interval = 16; // ~60fps
    const timer = setInterval(() => {
      if (!this.toasts[index]) {
        clearInterval(timer);
        return;
      }

      let elapsed = Date.now() - start;
      this.toasts[index].progress = Math.max(
        100 - (elapsed / duration) * 100,
        0
      );

      if (this.toasts[index].progress <= 0) {
        clearInterval(timer);
        this.removeToast(index);
      }
    }, interval);
  },

  removeToast(index) {
    this.toasts.splice(index, 1);
  },
}
//   methods: {
//     addToast({ message, type, duration, group }) {
//       const id = Date.now() + Math.random();
//       const toast = { id, message, type, duration, group, progress: 100 };

//       // Allow multiple actions (different group) but avoid duplicates in same group
//       if (
//         this.toasts.some(t => t.message === message && t.group === group)
//       ) {
//         return;
//       }

//       this.toasts.push(toast);

//       let start = Date.now();
//       let timer = setInterval(() => {
//         let elapsed = Date.now() - start;
//         toast.progress = Math.max(100 - (elapsed / duration) * 100, 0);

//         if (toast.progress <= 0) {
//           clearInterval(timer);
//           this.toasts = this.toasts.filter(t => t.id !== id);
//         }
//       }, 16);
//     },
//     removeToast(index) {
//       this.toasts.splice(index, 1);
//     }
//   }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
}

.toast {
  background: #333;
  color: white;
  padding: 10px;
  border-radius: 6px;
  min-width: 270px;
  max-width: 300px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.toast-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.toast-text {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toast-close {
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.toast-progress {
  height: 3px;
  background: #4caf50;
  position: absolute;
  bottom: 0;
  left: 0;
}

.toast.error .toast-progress {
  background: #f44336;
}
.toast.success .toast-progress {
  background: #4caf50;
}
.toast.info .toast-progress {
  background: #2196f3;
}
</style>
